import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IdentityFacade } from '@bp/admins-shared/domains/identity';

@Component({
	selector: 'bp-email-verification-page',
	templateUrl: './email-verification-page.component.html',
	styleUrls: [ './email-verification-page.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailVerificationPageComponent {

	constructor(
		public readonly identityFacade: IdentityFacade,
	) {
		this.identityFacade.verifyEmail();
	 }

}
